module.exports = __webpack_public_path__ + "img/slide-43.e2b67cb8.jpeg";